import React from 'react';
import './ListInventory.styles.css';

export const ListInventory = (props) => {
    return (
        <div className='ListInventoryWrapper'>
            List Inventory Works
        </div>
    )
}